import React from 'react';

function StatCard({ title, value, subtitle, icon, accent = 'indicador' }) {
  return (
    <div className="bg-white dark:bg-slate-800 rounded-lg shadow-sm p-5 border border-slate-100 dark:border-slate-700 break-inside-avoid">
      <div className="flex items-center justify-between mb-3">
        <div className="bg-primary/10 text-primary rounded-full p-2">
          <span className="material-symbols-outlined">{icon}</span>
        </div>
        <span className="text-[11px] font-semibold uppercase tracking-wide text-slate-500 dark:text-slate-400">
          {accent}
        </span>
      </div>
      <p className="text-sm text-slate-500 dark:text-slate-300">{title}</p>
      <p className="text-2xl font-bold text-slate-900 dark:text-white">{value}</p>
      {subtitle && (
        <p className="text-xs mt-1 text-slate-500 dark:text-slate-400">{subtitle}</p>
      )}
    </div>
  );
}

export default StatCard;
